import { AuthInterceptor } from './auth.interceptor';
import { ErrorInterceptor } from './error.interceptor';

export const interceptors = { AuthInterceptor, ErrorInterceptor };

export * from './auth.interceptor';
export * from './error.interceptor';
